module.exports = __webpack_public_path__ + "img/icon-admin.13e64c7d.svg";